export default __webpack_public_path__ + "static/media/gg6.c08f697d.jpeg";